import { OnInit } from '@angular/core';
import { TimelineDatePipe } from "@app/pipes/timeline-date.pipe";
import { DatePipe } from "@app/pipes/date.pipe";
import { TimePipe } from "@app/pipes/time.pipe";
var CsAgGridCustomCellRendererComponent = /** @class */ (function () {
    function CsAgGridCustomCellRendererComponent(timelineDateTime, shortDate, timePipe) {
        this.timelineDateTime = timelineDateTime;
        this.shortDate = shortDate;
        this.timePipe = timePipe;
        this.cellRenderData = [];
        this.showFullText = false;
    }
    CsAgGridCustomCellRendererComponent.prototype.ngOnInit = function () {
        if (this.params && this.params.hasOwnProperty('data')) {
            this.cellRenderData = this.params.data;
        }
    };
    CsAgGridCustomCellRendererComponent.prototype.hasContent = function (key, cellRenderData) {
        return !!(key.profileImage ||
            (key.type === 'custom_icon' && key.iconsList[cellRenderData[key.iconKey]]) ||
            (key.type === 'static_icon' && key.iconName) ||
            (key.text && cellRenderData[key.text]) ||
            (key.customText && key.customTextList[cellRenderData[key.customTextKey]]));
    };
    CsAgGridCustomCellRendererComponent.prototype.refresh = function (params) {
        throw new Error("Method not implemented.");
    };
    CsAgGridCustomCellRendererComponent.prototype.isDateObject = function (value) {
        return value && typeof value === 'object' && 'date' in value;
    };
    CsAgGridCustomCellRendererComponent.prototype.getUserDate = function (val) {
        var shortdate = this.shortDate.transform(val);
        var usertime = this.timePipe.transform(val);
        var userDatetime = shortdate + ' (' + usertime + ')';
        return userDatetime;
    };
    CsAgGridCustomCellRendererComponent.prototype.getIconClass = function (iconValue) {
        if (typeof iconValue === 'number' || !isNaN(Number(iconValue))) {
            var id = typeof iconValue === 'number' ? iconValue : parseInt(iconValue, 10);
            return this.getIconById(id);
        }
        return iconValue; // return as-is if it's already a string (class name)
    };
    CsAgGridCustomCellRendererComponent.prototype.getIconById = function (id) {
        var createdByTypes = this.getCreatedbyType();
        var foundType = createdByTypes.find(function (item) { return item.id === id.toString(); });
        return foundType ? foundType.icon : '';
    };
    CsAgGridCustomCellRendererComponent.prototype.getCreatedbyType = function () {
        return [
            { id: '1', text: 'System', icon: 'fa-sharp fa-regular fa-globe' },
            { id: '2', text: 'Online', icon: 'fa-sharp fa-regular fa-globe' },
            { id: '3', text: 'Webservice', icon: 'fa-sharp fa-regular fa-globe' },
            { id: '4', text: 'iPhone', icon: 'fa fa-apple' },
            { id: '5', text: 'iPad', icon: 'fa fa-apple' },
            { id: '6', text: 'Android tablet', icon: 'fa fa-brands fa-android' },
            { id: '8', text: 'Android phone', icon: 'fa fa-brands fa-android' },
        ];
    };
    return CsAgGridCustomCellRendererComponent;
}());
export { CsAgGridCustomCellRendererComponent };
